// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"34ac39a2","643":"34ac39a2","815":"34ac39a2","818":"34ac39a2","903":"34ac39a2"}[chunkId] + ".chunk.css";
};